export const removeZip = (address) => {
    return address?.replace(/\s\d{5}/, '');
};
export const splitAddress = (address) => {
    const line1 = removeZip?.(address)?.split(', ')?.[0] ?? '';
    const line2 = removeZip?.(address)?.split(', ').slice(1).join(', ') ?? '';
    const zipCode = address?.match(/\s\d{5}/)?.[0] ?? '';
    return { addressLine1: line1, addressLine2: line2, zipCode };
};
export const deriveBoroughFromAddress = (address) => {
    if (!address)
        return null;
    return address.split(', ')[1]?.trim() ?? null;
};
